import { useNavigate, useParams } from 'react-router-dom';

import { type RouteContext, createNavigator, extractRouteParams } from '@web/app/shared/utils/route-utils';

interface AgentSettingsParams extends RouteContext {
    id?: string;
}

export const useAgentSettings = () => {
    const routeParams = extractRouteParams<AgentSettingsParams>(useParams());
    const { id, workspaceId, projectId } = routeParams;
    const navigate = useNavigate();
    const navigator = createNavigator(navigate, { workspaceId, projectId });

    const handleFormSuccess = () => {
        navigator.navigateTo('/agent-catalogs');
    };

    const handleCancel = () => {
        navigator.navigateTo('/agent-catalogs');
    };

    return {
        agentId: id,
        handleFormSuccess,
        handleCancel,
    };
};
